import {
  line,
  curveLinear,
  curveNatural,
  max,
  min,
  circle,
  title,
  text,
} from "d3";
import { useState } from "react";
import { useEffect } from "react";

export const ProcessLine = ({
  data,
  processType,
  xScale,
  yScale,
  xValue,
  yValue,
  tooltipFormat,
  dllProcess,
  isSmallScreen,
  heater,
  cooler,
}) => {
  const xProcessValue = (d) => d.absoluteHumidity;
  const yProcessValue = (d) => d.temperatureDryBulb;

  return (
    <>
      <path
        fill="none"
        stroke="#000"
        strokeWidth={isSmallScreen ? 0.7 : 1.5}
        clipPath="url(#clip-path)"
        d={line()
          .x((d) => xScale(xProcessValue(d)))
          .y((d) => yScale(yProcessValue(d)))
          .curve(curveLinear)(data)}
      ></path>
      {data.map((point, index) => (
        <>
          <circle
            clipPath="url(#clip-path)"
            cx={xScale(xProcessValue(point))}
            cy={yScale(yProcessValue(point))}
            r={
              dllProcess === "EHA" || dllProcess === "SUP"
                ? isSmallScreen
                  ? 5
                  : 10
                : 5
            }
            stroke="#000"
            stroke-width={
              dllProcess === "EHA" || dllProcess === "SUP" ? "0" : data.length
            }
            fill={
              dllProcess === "EHA" || dllProcess === "SUP"
                ? "#80CAEF"
                : "#D3D3D3"
            }
            //fill="#80CAEF"
            //fill={point.process === "cooling" ? "blue" : "black"}
          >
            <title>
              {"Temp. Dry bulb: " +
                tooltipFormat(yProcessValue(point)) +
                " °C" +
                " \n Abs.humidity: " +
                tooltipFormat(xProcessValue(point)) +
                " g/kg"}
            </title>
          </circle>

          <text
            //fontSize={86}
            clipPath="url(#clip-path)"
            font-family="Poppins, sans-serif"
            fontSize={isSmallScreen ? 8 : 16}
            transform={
              dllProcess === "EHA" || dllProcess === "SUP"
                ? isSmallScreen
                  ? "translate(-2 2.5)"
                  : "translate(-4 5)"
                : isSmallScreen
                ? "translate(-2 2.5)"
                : "translate(7 10)"
            }
            x={xScale(xProcessValue(point))}
            y={yScale(yProcessValue(point))}
          >
            {dllProcess === "EHA"
              ? heater
                ? index + 4
                : cooler
                ? index + 4
                : index + 3
              : index + 1}
          </text>
        </>
      ))}
    </>
  );
};
